<div class="my-5">
  <sm-page-header [breadcrumb]="breadcrumb" title="agpm.history.title"> </sm-page-header>

  <div class="content">
      <sm-data-table-builder [dataTableObject]="dataTableObject" [datas]="data" [totalRecords]="totalRecords" [loading]="loading"></sm-data-table-builder>
  </div>
